module.exports = __webpack_public_path__ + "img/praxis-lambrette-logo.7cb34fdf.svg";